<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<template>
  <el-dialog
      v-dialogDrag
      title="查看车辆"
      :visible="visible"
      width="80%"
      @open="open"
      @close="close"
      :close-on-click-modal="false"
  >
    <div
        class="dialog_box"
        v-loading="loading"
        element-loading-text="请稍候..."
    >
      <el-tabs
          v-model="activeName"
          tab-position="left"
          @tab-click="handleClick"
      >
        <el-tab-pane label="基本信息" name="first"
        >
          <el-form label-width="100px" :model="form" ref="form">
<!--            <el-form-item label="车辆类型" prop="carType">-->
<!--              <el-select v-model="form.carType" placeholder="请选择" size="medium" disabled>-->
<!--                <el-option-->
<!--                    v-for="item in carTypeoptions"-->
<!--                    :key="item.value"-->
<!--                    :label="item.name"-->
<!--                    :value="item.value"-->
<!--                >-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="状态" prop="state">-->
<!--              <el-select v-model="form.state2" placeholder="请选择" size="medium">-->
<!--                <el-option-->
<!--                    v-for="item in optionsCarState"-->
<!--                    :key="item.value"-->
<!--                    :label="item.name"-->
<!--                    :value="item.value"-->
<!--                >-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="姓名" prop="carOwner">
              <el-input v-model="form.carOwner" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="车牌号码" required>
              <el-input v-model="form.carNo" size="medium" readonly></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model="form.phone" size="medium"></el-input>
            </el-form-item>
<!--            <el-form-item label="积分" prop="score">-->
<!--              <el-input v-model="form.score" size="medium" readonly></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="累计违章次数" prop="score">-->
<!--              <el-input v-model="form.sumBreakRule" size="medium" readonly></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="来源" prop="origin">-->
<!--              <el-select v-model="form.origin" placeholder="请选择" size="medium" disabled>-->
<!--                <el-option-->
<!--                    v-for="item in optionsCarOrigin"-->
<!--                    :key="item.value"-->
<!--                    :label="item.name"-->
<!--                    :value="item.value"-->
<!--                >-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="备注" prop="note">-->
<!--              <el-input type="textarea" v-model="form.note" rows='10'></el-input>-->
<!--            </el-form-item>-->
            <div style="text-align: right; margin: 0; margin-top: 15px;">
              <el-button size="medium" type="primary"   @click="updateForm()"
              >保存</el-button
              >
            </div>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="行动轨迹" name="second">
          <div style="box-sizing: border-box; padding: 10px 20px">
            <div class="query_box">
              <el-form
                  :model="xdgj_form"
                  ref="xdgj_form"
                  label-position="100px"
                  size="medium"
              >
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="时间范围" prop="date">
                      <el-date-picker
                          v-model="xdgj_form.date"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          format="yyyy 年 MM 月 dd 日"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions1">
                        >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        @click="xingdongguiji()"
                    >查询
                    </el-button
                    >
                    <el-button size="medium" icon="el-icon-refresh" @click="xingdongguiji('no')">重置</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <el-row style="border: 1px solid #ccc">
              <el-col :span="8">
                <div class="time_box">
                  <el-steps direction="vertical" :active="xdgjData.length">
                    <el-step
                        v-for="(item, i) in xdgjData"
                        :key="i"
                        :title="item.triggerType"
                    >
                      <template slot="description">
                        <span>{{ item.outEntranceNametext }}  {{ item.triggerTime }}</span>
<!--                        <el-image-->
<!--                            src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"  ></el-image>-->
                        <el-image v-if="item.carPicUrl !== null && item.carPicUrl !== ''"
                            :src="imgUrl + item.carPicUrl" :preview-src-list="[imgUrl +item.carPicUrl]" ></el-image>
                      </template>
                    </el-step>
                  </el-steps>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="map_container" id="map_container"></div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="通行记录" name="third">
          <div style="box-sizing: border-box; padding: 10px 20px">
            <div class="query_box">
              <el-form
                  :model="tx_form"
                  ref="tx_form"
                  label-position="100px"
                  size="medium"
              >
                <el-row>
                  <el-col
                      :span="12"
                      style="padding: 0 20px"
                      class="item_date_input"
                  >
                    <el-form-item label="时间范围：" prop="date">
                      <el-date-picker
                          v-model="tx_form.date"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          format="yyyy 年 MM 月 dd 日"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions2">
                        >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        @click="tongxingjiluClick()"
                    >查询
                    </el-button
                    >
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <el-table border size="medium" :data="txData" style="width: 100%">
              <el-table-column prop="carOwner" label="姓名" width="180">
              </el-table-column>
              <el-table-column prop="carNo" label="车牌号" width="180">
              </el-table-column>
              <el-table-column prop="carPosition" label="驶向" width="180">
              </el-table-column>
              <el-table-column prop="gateName" label="出入口名称" width="180">
              </el-table-column>
              <el-table-column prop="inTime" label="通行时间"></el-table-column>
              <el-table-column prop="type" label="通行方式"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import dialog from "@/components/mixins/dialog";
import {findCarInOut, findCarInOutNew, getCarGj, getCarGjNew, updateForm} from "./api/index"

export default {
  mixins: [dialog],
  data() {
    return {
      imgUrl: process.env.VUE_APP_BASE_API + '/user',
      form: {
        state: "",
        state2: "",
        carType: "",
        carOwner: "",
        carNo: "",
        phone: "",
        score: "",
        sumBreakRule: "",
        origin: "",
        note: "",
      },
      pickerOptions1: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      pickerOptions2: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      carTypeoptions: [
        {"name": "临时车", "value": "0"},
        {"name": "VIP车", "value": "1"}
      ],
      optionsCarState: [
        {name: "正常", value: "0"},
        {name: "异常", value: "1"}
      ],
      optionsCarOrigin: [
        {"name": "手机端登记", "value": "0"},
        {"name": "车辆系统同步", "value": "1"},
        {"name": "临时添加", "value": "2"}
      ],
      options: [],
      optionsCampus: [],
      optionsUserOrigin: [
        {"name": "校内", "value": "0"},
        {"name": "校外", "value": "1"}
      ],
      imageUrl: "",
      activeName: "first",
      xdgj_form: {
        date: [],
      },
      xdgjData: [],
      xsd_colors: ["#99A9BF", "#409EFF", "#67C23A"],
      xsgj_event_list: [
        {
          name: "摄像头捕捉 168.132.26.01",
          time: "2021-05-06 15:33:21-2021-05-06  16:33:21",
          images:
              "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        },
        {
          name: "摄像头捕捉 168.132.26.02",
          time: "2021-05-06 15:33:21-2021-05-06  16:33:21",
          images:
              "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        },
        {
          name: "摄像头捕捉 168.132.26.03",
          time: "2021-05-06 15:33:21-2021-05-06  16:33:21",
          images:
              "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        }
      ],
      tx_form: {
        date: [],
      },
      txData: [],
      lineArr1: [
        [120.484979, 36.11991], // 出口
        [120.484024, 36.119892],  // 球场东向
        [120.483949, 36.119728],  // 球场西向
        [120.483777, 36.119442],
        [120.483702, 36.119303],
        [120.48352, 36.11913],
        [120.483466, 36.119268],
        [120.483391, 36.119416]
      ],
      lineArr2: [
        [120.484947, 36.119918],
        [120.484056, 36.119875],
        [120.483992, 36.119875],
        [120.483971, 36.119745],
        [120.483863, 36.119485],
        [120.483659, 36.119294],
        [120.483595, 36.119173],
        [120.483241, 36.11893],
        [120.482436, 36.11874],
        [120.479904, 36.1188]
      ],
      lineArr3: [
        [120.484966, 36.119924],
        [120.484001, 36.119889],
        [120.484033, 36.12031],
        [120.483926, 36.120626],
        [120.483818, 36.120821],
        [120.483609, 36.121072],
        [120.483099, 36.121341],
        [120.482343, 36.121653],
        [120.482343, 36.121653],
        [120.482944, 36.12326],
        [120.482874, 36.123486],
        [120.482584, 36.123945]
      ],
      lineArr4: [
        [120.484947, 36.119918],
        [120.484056, 36.119875],
        [120.483992, 36.119875],
        [120.483971, 36.119745],
        [120.483863, 36.119485],
        [120.483659, 36.119294],
        [120.483595, 36.119173],
        [120.483241, 36.11893],
        [120.482436, 36.11874],
        [120.479904, 36.1188],
        [120.477934, 36.118819],
        [120.477912, 36.119807],
        [120.478341, 36.119911],
        [120.478894, 36.11998],
        [120.479693, 36.12005],
        [120.480787, 36.120149],
        [120.480798, 36.120158],
        [120.481034, 36.120167],
        [120.481495, 36.12011],
        [120.481512, 36.120197],
        [120.481399, 36.120284],
        [120.481356, 36.120353],
        [120.481442, 36.120574],
        [120.48178, 36.121029],
        [120.482359, 36.121649],
        [120.482885, 36.122576],
        [120.482949, 36.123104],
        [120.482885, 36.123486],
        [120.48288, 36.123486]
      ],
    };
  },
  methods: {
    xingdongguiji(form) {
      if (this.xdgj_form.date[0] == null ) {
        const end = new Date();
        const start = new Date();
        this.xdgj_form.date = [start.format("yyyy-MM-dd"), end.format("yyyy-MM-dd")]
      }
      if(form === 'no'){
        this.xdgj_form.date=[]
      }
      let data = Object.assign({}, Object);
      data.carNo = this.form.carNo;
      data.current = 1;
      data.size = 9999;
      if (this.xdgj_form.date != null) {
        data.beginDay = this.xdgj_form.date[0];
        data.endDay = this.xdgj_form.date[1];
      }
      getCarGjNew(data).then(res => {
        let data = res.data.data;
        var marker,
            lineArr;
        lineArr = data
        // if (data == '1') {
        //   lineArr = this.lineArr1
        // }
        // if (data == '2') {
        //   lineArr = this.lineArr2
        // }
        // if (data == '3') {
        //   lineArr = this.lineArr3
        // }
        // if (data == '4') {
        //   lineArr = this.lineArr4
        // }
        var map = new AMap.Map("map_container", {
          resizeEnable: true,
          center: [120.480743, 36.121498],
          zoom: 17
        });

        marker = new AMap.Marker({
          map: map,
          position: lineArr[0],
          icon: "https://webapi.amap.com/images/car.png",
          offset: new AMap.Pixel(-26, -13),
          autoRotation: true,
          angle: -90,
        });

        // 绘制轨迹
        var polyline = new AMap.Polyline({
          map: map,
          path: lineArr,
          showDir: true,
          strokeColor: "#28F",  //线颜色
          // strokeOpacity: 1,     //线透明度
          strokeWeight: 6,      //线宽
          // strokeStyle: "solid"  //线样式
        });

        var passedPolyline = new AMap.Polyline({
          map: map,
          // path: lineArr,
          strokeColor: "#AF5",  //线颜色
          // strokeOpacity: 1,     //线透明度
          strokeWeight: 6,      //线宽
          // strokeStyle: "solid"  //线样式
        });


        marker.on('moving', function (e) {
          passedPolyline.setPath(e.passedPath);
        });

        map.setFitView();
        marker.moveAlong(lineArr, 100);
      });
      findCarInOutNew(data)
          .then((res) => {
            this.xdgjData = res.data.data.records;
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            })
          });
      // findCarInOut(data)
      //     .then((res) => {
      //       this.xdgjData = res.data.data.records;
      //     })
      //     .catch((err) => {
      //       this.loading = false;
      //       this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
      //         type: "error",
      //       })
      //     });
    },
    handleClick() {

      if (this.activeName == "second") {
        this.xingdongguiji();
        //[[120.481565,36.1196],[120.481618,36.119814],[120.481494,36.120213],[120.481759,36.121012],[120.48235,36.121647]];
      }

      if (this.activeName == "third") {
        // let data = Object.assign({},Object);
        // data.carNo = this.form.carNo;
        // data.current = 1;
        // data.size = 20;


        // findCarInOut(data)
        //   .then((res) => {
        //     this.txData = res.data.data.records;
        //   })
        //   .catch((err) => {
        //     this.loading = false;
        //     this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
        //       type: "error",
        //     })
        //   });
        this.tongxingjiluClick();
      }

    },
    tongxingjiluClick() {
      let data = Object.assign({}, Object);
      data.carNo = this.form.carNo;
      data.current = 1;
      data.size = 20;
      if (this.tx_form.date != null) {
        data.startTime = this.tx_form.date[0];
        data.endTime = this.tx_form.date[1];
      }
      findCarInOut(data)
          .then((res) => {
            this.txData = res.data.data.records;
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            })
          });

    },
    updateForm() {
      let data = Object.assign({}, Object);
      data.state = this.form.state2;
      data.carOwner = this.form.carOwner;
      data.carNo = this.form.carNo;
      data.phone = this.form.phone;
      data.note = this.form.note;
      updateForm(data)
          .then((res) => {
            if(res.data.code === 20000){
              this.$message({
                type: 'success',
                message: '修改成功'
              });
            }else {
              this.$message({
                type: 'error',
                message: '修改失败'
              });
            }
            this.$emit('find',null);
           this.close()
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            })
          });

    },
    open(name = 'form') {
      //打开对话框先清除上次残留数据

      if (this.$refs[name]) {
        this.$refs[name].resetFields();
      }
      if (this.$refs['tx_form']) {
        this.$refs['tx_form'].resetFields();
      }
      if (this.data) {
        let obj = this[name]
        for (let key in obj) {
          obj[key] = this.data[key]
        }
      }
      //对话框打开后执行
      if (this.afterOpen && typeof (this.afterOpen) === 'function') {
        this.afterOpen()
      }
      this.activeName = "first";
    },
  },
};
</script>
<style scoped>
.dialog_box .form_body {
  max-height: 50vh;
  overflow-y: auto;
}

.submit_box {
  text-align: center;
  border-top: 1px solid #409eff;
  padding-top: 20px;
}

.form_title {
  border-left: 5px solid #409eff;
  margin: 0;
  padding: 0 0 0 10px;
  margin-bottom: 15px;
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
  font-weight: 700;
  font-style: normal;
  text-align: left;
  color: #666666;
  font-size: 14px;
  height: 22px;
  line-height: 22px;
}

.time_box {
  width: 100%;
  height: 50vh;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 15px 25px;
}

.map_container {
  width: 100%;
  height: 50vh;
}
</style>


